import styled from "styled-components";
import bg from "../../images/footer-photo.webp";

export const FooterSect = styled.footer`
    padding: 60px 0;
    background-image: url(${bg});
    background-size: cover; 
    background-position: center;
`;

export const Text = styled.p`
   color: #FFF;
    font-size: 40px;
    font-weight: 800;
`;